/* Core-on-demand: loaded only when predictive search is enabled and rendered. */
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { PredictiveSearch } from '@/scripts/optional/predictive-search'

q.safeDefineElement(PredictiveSearch)
